




























import { Component, Vue } from "vue-property-decorator";
import { GuidelineApi } from "../components/guidelines/guidelineApi";
import ProgramPage from "../components/programs/ProgramPage.vue";
import GuidelineRow from "../components/guidelines/GuidelineRow.vue";
import GuidelineRecorder from "../components/guidelines/GuidelineRecorder.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzTitle from "../components/cz/CzTitle.vue";
import CzAccordion from "../components/cz/CzAccordion.vue";
import CzUndoBar from "../components/cz/CzUndoBar.vue";

@Component({ components: { ProgramPage, GuidelineRow, GuidelineRecorder, CzCard, CzTitle, CzAccordion, CzUndoBar } })
export default class GuidelinesPage extends Vue {
  rows: any[] = [];
  today: string = "";
  loaded: boolean = false;
  failed: boolean = false;
  busyId: number = 0;
  showEnded: boolean = false;

  get current(): any[] {
    return this.rows.filter((r: any) => !r.ended);
  }

  get ended(): any[] {
    return this.rows.filter((r: any) => r.ended);
  }

  get backTo(): string {
    return (this.$route.query.back as string) || "/today";
  }

  get backLabel(): string {
    return this.backTo === "/today" ? this.$t("Today").toString() : this.$t("Back").toString();
  }

  get emptyText(): string {
    return this.loaded && !this.failed && !this.rows.length ? this.$t("You have no guidelines").toString() : "";
  }

  link(row: any): string {
    return `/guidelines/${row.id}?back=${encodeURIComponent(this.$route.fullPath)}`;
  }

  toggle(row: any) {
    (this.$refs.recorder as any).toggle(row);
  }

  updateRow(row: any) {
    this.rows = this.rows.map((r) => (r.id === row.id ? row : r));
  }

  async load() {
    const res = await GuidelineApi.list().catch(() => null);
    this.failed = !res || res.ok !== true;
    this.rows = this.failed ? [] : res.data;
    this.today = this.failed ? "" : GuidelineApi.day(res.today);
    this.loaded = true;
  }

  mounted() {
    return this.load();
  }
}
